import { defineComponent as _defineComponent } from 'vue';
import { BPopover } from "bootstrap-vue";
import { useUserStore } from "@/stores/userStore";
import { withPrefix } from "@/utils/redirect";
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoginRequired',
    props: {
        title: null,
        target: null
    },
    setup(__props) {
        const userStore = useUserStore();
        return { __sfc: true, userStore, BPopover, withPrefix };
    }
});
